/* eslint-disable */
export default {
  noRecords: 'No recent records found.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
